var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { staticClass: "c-radio-list" },
    [
      _c(
        "legend",
        { staticClass: "c-radio-list__title c-rap-radio-group__title--inline" },
        [
          _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
          _vm.required
            ? _c("span", { staticClass: "c-radio-group__required" }, [
                _vm._v("*")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.tooltip
            ? _c(
                "div",
                { staticClass: "c-tooltip" },
                [
                  _c(
                    "ToolTip",
                    {
                      attrs: {
                        title: _vm.tooltip.title,
                        isActive: _vm.isActiveTooltip
                      },
                      on: {
                        toggleTooltip: function(value) {
                          return _vm.$emit("toggleTooltip", value)
                        }
                      }
                    },
                    [
                      _vm.tooltip.body
                        ? _c("div", {
                            domProps: { innerHTML: _vm._s(_vm.tooltip.body) }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tooltip.image.url
                        ? _c("img", {
                            attrs: {
                              src: _vm.tooltip.image.url,
                              alt: _vm.tooltip.image.alt
                            }
                          })
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.collapsibleContent
        ? _c("CollapsibleContent", {
            attrs: { content: _vm.collapsibleContent }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.helptext
        ? _c("div", {
            staticClass: "c-rte helptext",
            domProps: { innerHTML: _vm._s(_vm.helptext) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "validation-message",
        {
          attrs: {
            valid: _vm.valid,
            invalid: _vm.invalid,
            validationMessage: _vm.validationMessage
          }
        },
        [
          _c(
            "div",
            { staticClass: "c-radio-list__list" },
            _vm._l(_vm.options, function(option, index) {
              return _c(
                "label",
                {
                  key: index,
                  staticClass: "c-radio-list__button",
                  class: { "is-active": _vm.isOptionActive(option) },
                  attrs: { for: _vm.groupName + "-" + index }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedValue,
                        expression: "selectedValue"
                      }
                    ],
                    staticClass: "visually-hidden",
                    attrs: {
                      id: _vm.groupName + "-" + index,
                      name: _vm.groupName,
                      type: "radio"
                    },
                    domProps: {
                      value: option.value,
                      checked: _vm._q(_vm.selectedValue, option.value)
                    },
                    on: {
                      change: [
                        function($event) {
                          _vm.selectedValue = option.value
                        },
                        function($event) {
                          return _vm.handleRadioClick(index, option)
                        }
                      ]
                    }
                  }),
                  _vm._v("\n        " + _vm._s(option.label) + "\n    ")
                ]
              )
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-566e5a0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-566e5a0e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/forms/radio-list/RadioList.vue
// module id = 702
// module chunks = 0